<template>
  <div>
    <input type="checkbox" id="dropdown" />
    <label class="dropdownTitle" for="dropdown">
      <div class="or-separator">oder Datei hochladen</div>
      <img class="dropdownIcon minus" src="../../assets/img/ic_minus.svg" />
      <img class="dropdownIcon plus" src="../../assets/img/ic_plus.svg" />
    </label>
    <div class="optionInput oi-color dropdownContent">
      <div>
        <label class="btnMenuPrimary upload-button-label">
          <input
            class="input-file"
            type="file"
            :disabled="isSaving"
            @change="fileChange($event.target.files)"
          />
          Datei auswählen
        </label>
        <div v-if="fileErrors" class="errorText">
          {{ fileErrors[0] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { backendUrl } from '../../util/endpointConfig'
import { isBelowMaxFileSize } from '../../provider/smosterProvider'
import { trackProblemEvent } from '../../util/tracker'
import { store } from '../../store/store'

export default {
  name: 'FileUpload',
  data: function() {
    return {
      isSaving: false,
      soundLoadedCheckInterval: null,
      soundFile: null,
      convertedFileUrl: null,
      acceptedFileEndings: [
        '.aac',
        '.ac3',
        '.aif',
        '.aifc',
        '.aiff',
        '.amr',
        '.au',
        '.caf',
        '.flac',
        '.m4a',
        '.m4b',
        '.mp3',
        '.oga',
        '.sfark',
        '.voc',
        '.wav',
        '.weba',
        '.wma',
      ],
      fileErrors: [],
    }
  },
  props: {
    p5container: Object,
  },
  computed: {},

  methods: {
    hasAcceptedFileEnding(fileEnding) {
      return this.acceptedFileEndings.includes(fileEnding.toLowerCase())
    },
    getFileErrorMessages(file, fileEnding) {
      const errorMessages = []
      if (!this.hasAcceptedFileEnding(fileEnding)) {
        trackProblemEvent('FileUpload', 'FileFormatNotSupported')
        errorMessages.push(
          `Das Dateiformat ${fileEnding} wird nicht unterstützt`
        )
      }
      if (!isBelowMaxFileSize(file)) {
        errorMessages.push('Die Datei darf maximal 6 MB groß sein')
        trackProblemEvent('FileUpload', 'FileSizeTooBig')
      }
      return errorMessages
    },
    fileChange: async function(files) {
      const file = files[0]
      const fileEnding = file.name.match(/\.[0-9a-z]+$/i)[0]
      this.fileErrors = this.getFileErrorMessages(file, fileEnding)

      if (this.fileErrors.length === 0) {
        this.$emit('fileProcessingStateChanged', { isProcessing: true })

        await store.dispatch('uploadAudio', { file: files[0], type: 'FILE' })

        const audioUrl = `${backendUrl}smoster/${store.state.smosterId}/recording.wav`
        const convertedFileResponse = await fetch(audioUrl, {
          method: 'GET',
        })
        if (!convertedFileResponse.ok) {
          throw new Error(
            `Request for smoster ${convertedFileResponse.url} failed with code ${convertedFileResponse.status}. Are you talking to the correct backend?`
          )
        }

        let convertedFileBlob = await convertedFileResponse.blob()
        convertedFileBlob = new Blob([convertedFileBlob], { type: 'audio/wav' }) // without this safari doesn't know it's a wav
        this.convertedFileUrl = window.URL.createObjectURL(convertedFileBlob)

        const file = new File([convertedFileBlob], 'recording.wav', {
          type: 'audio/wav',
        })

        this.soundFile = file
        this.p5SoundFile = this.p5container.loadSound(file)

        this.soundLoadedCheckInterval = setInterval(
          this.checkP5SoundFileLoaded,
          500
        )
      }
    },
    checkP5SoundFileLoaded: function() {
      if (this.p5SoundFile.isLoaded()) {
        clearInterval(this.soundLoadedCheckInterval)
        this.$emit('audioAvailable', {
          p5soundFile: this.p5SoundFile,
          audioUrl: this.convertedFileUrl,
          isRecording: false,
        })
        this.$emit('fileProcessingStateChanged', { isProcessing: false })
      }
    },
  },
}
</script>

<style>
.input-file {
  /* The idea behind this css is to be visually hidden but accessible to screenreaders */
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap; /* 1 */
  clip-path: inset(50%);
}

.upload-button-label {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 2px;
}

.or-separator {
  width: 100%;
  text-align: center;
  margin-top: 0.35em;
  margin-bottom: 0.35em;
}
</style>
